import React from 'react';
import { useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import { getApplicationByNumber } from 'api';
import LoadableLoading from 'components/LoadableLoading';
import { getApplicationExecutor, getDefaultSigners, getUserRights, loadSurveyAct } from './api';

export const path = '/application/:applicationNumber/survey-act';

export const getSurveyActPath = (applicationNumber: string) => `${applicationNumber}/survey-act`;

const PageSurveyAct: React.FC = (props) => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();

  const SurveyAct = Loadable.Map({
    loader: {
      page: () => import('./page'),
      application: () => getApplicationByNumber(applicationNumber),
      // Бэкенд отвечает 403, если пользователь не подписант и не в оргструктуре объекта:
      // страница в этом случае показывает экран без доступа, а не ошибку загрузки
      surveyAct: () => loadSurveyAct(applicationNumber).catch(() => null),
      // Состав по умолчанию нужен только для нового акта, но грузится одним запросом заранее:
      // страница не знает до загрузки, есть ли акт по заявке
      defaultSigners: () => getDefaultSigners(applicationNumber).catch(() => []),
      executor: () => getApplicationExecutor(applicationNumber),
      rights: () => getUserRights(applicationNumber),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <SurveyAct {...props} />;
};

export default PageSurveyAct;
